export function copyToClipboard(text) {
  try {
    const fakeTextField = document.createElement('textarea');
    fakeTextField.innerText = text;
    document.body.appendChild(fakeTextField);
    fakeTextField.select();
    document.execCommand('copy');
    fakeTextField.remove();
  } catch (err) {
    console.error(`Error while copying ${text} to the clipboard.`, err);
  }
}
